import { Component, OnInit, ElementRef } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToasterService } from 'src/app/services/toaster.service';
import { NgForm } from '@angular/forms';

declare const $;

export interface Credentials {
  username: string;
  password: string;
  token: string;
}

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {



credentials: Credentials;
public autoLogin: boolean = true;
signInError: string;
submitting = false;
forgotPassword = false;
forgotPwdError: string;
model: any = {};
loading = false;
returnUrl: string;
mToken: string;
isButtonDisabled = false;
signUpMessage = '';

roleId;

email: any;



  constructor(
    public authService: AuthService,
    private router: Router,
    private elm: ElementRef,
    private activatedRoute: ActivatedRoute,
    private alertService: ToasterService,
  ) { }

  ngOnInit() {
  }


public Login(loginForm: NgForm) {
  this.loading = true;
  this.signInError = '';
  this.credentials = Object.assign({}, loginForm.value);
  if (this.credentials.username === '' || this.credentials.password === '') {
    this.signInError = 'Provide username and password';
    this.loading = false;
    this.alertService.Error('Provide username and password');
  } else if (this.credentials.password.startsWith(' ') || this.credentials.username.startsWith(' ')) {
    this.loading = false;
    this.alertService.Error('Username or password should not contain space');
    this.signInError = 'Username or password should not contain space';

  } else {
    this.isButtonDisabled = true;
    this.credentials.token = this.mToken;
    this.authService.Login(this.credentials).subscribe((response) => {

      if (response) {

        loginForm.reset();

        // const loginResponseData = JSON.parse(response._body);
        this.authService.setToken(response.Token);
        this.authService.setLoginUser(response);
        this.submitting = true;

        this.switchToDashboard();
        this.loading = false;
      
      } else {
        this.submitting = false;
        this.isButtonDisabled = false;
        // this.signInError = response._body;
        this.loading = false;
        this.alertService.Error(response._body);
      }
    },
      (err) => {
        this.loading = false;
        this.returnedMessage(err);
      }
    );
  }
}



ForgotPassword(form: NgForm) {

  this.loading = true;

  this.email = form.value.email;
  this.authService.forgotPassword(this.email).subscribe(res => {
    form.reset();
    this.loading = false;

    this.alertService.Success('The password has been sent to your email');
    this.closeModelChangePassword();

  }
  ,
    (err) => {
      this.loading = false;

      this.alertService.Error(err);
    });
}

returnedMessage(error: Response) {
  this.isButtonDisabled = false;
  this.alertService.Error(error + '');
}

switchToDashboard() {

  if (this.authService.getCurrentUser().RoleId === 1 ) {
    this.router.navigate(['../../admin/userList']);
  } else if (this.authService.getCurrentUser().RoleId === 2 ) {
    this.router.navigate(['../../logFrame/overview']);
  } else if (this.authService.getCurrentUser().RoleId === 3 ) {
    this.router.navigate(['../../logFrame/overview']);
  } else if (this.authService.getCurrentUser().RoleId === 4 ) {
    this.router.navigate(['../../logFrame/overview']);
  } else if (this.authService.getCurrentUser().RoleId === 5) {
    this.router.navigate(['../../logFrame/overview']);
  } 



}

closeModelChangePassword() {
  $(this.elm.nativeElement.querySelector('#myResetpassword')).modal('hide');

}

}
